import React, { useState, useEffect } from "react";
import { api } from "../../api/apiService";
import { useForm } from "react-hook-form";
import { Modal, Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";

const schema = yup.object().shape({
    time: yup.string().required("Time is required"),
});

const AdminUpdateChecktime = ({ show, onClose, currentEmployee, employeeId, onAttendanceUpdated }) => {
    const [isSaving, setIsSaving] = useState(false);
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const formatTimeForInput = (timeStr) => {
        if (!timeStr) return "";
        return moment(timeStr, "hh:mm A").format("HH:mm");
    };

    useEffect(() => {
        if (currentEmployee) {
            setValue(
                "time",
                currentEmployee.check_type === "Check In"
                    ? formatTimeForInput(currentEmployee.check_in)
                    : formatTimeForInput(currentEmployee.check_out)
            );
        }
    }, [currentEmployee, setValue]);

    const onSubmit = async (data) => {
        try {
            setIsSaving(true);
            const payload = {
                ...data,
                date: moment(currentEmployee?.date, "DD-MM-YYYY").format("YYYY-MM-DD"),
                time: moment(data.time, "HH:mm").format("hh:mm A"),
                check_type: currentEmployee?.check_type,
                employee_id: employeeId,
                check_in_record_id: currentEmployee?.check_in_record_id,
                check_out_record_id: currentEmployee?.check_out_record_id,
            };
            const response = await api.post("/admin/update-checktime", payload);
            toast.success(response.data.message);
            reset();
            onClose();
            if (onAttendanceUpdated) {
                onAttendanceUpdated();
            }
        } catch (error) {
            console.log(error)
            if (error?.data?.errors) {
                error.data.errors.forEach((err) => toast.error(err));
            } else if (error) {
                toast.error(error?.data?.message);
            } else {
                toast.error("An error occurred. Please try again.");
            }
        } finally {
            setIsSaving(false);
        }
    };

    if (!show) return null;

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <h5 className="modal-title text-dark">Update {currentEmployee?.check_type} Time</h5>
            </Modal.Header>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label fw-bold text-dark">
                                Select {currentEmployee?.check_type === "Check In" ? "Check In" : "Check Out"} Time
                            </label>
                            <input
                                type="time"
                                className={`form-control ${errors.time ? "is-invalid" : ""}`}
                                {...register("time")}
                            />
                            <div className="invalid-feedback">{errors.time?.message}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={onClose} disabled={isSaving}>
                        Close
                    </button>
                    <button className="btn btn-primary" type="submit" disabled={isSaving}>
                        {isSaving ? "Saving..." : "Save"}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default AdminUpdateChecktime;
